"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _attributeSelector = _interopRequireDefault(require("@cimpress-technology/attribute-selector"));

var _map = _interopRequireDefault(require("lodash/map"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var productState = {};

var CompetitorProductsAggregatorEachForProduct =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(CompetitorProductsAggregatorEachForProduct, _PureComponent);

  var _super = _createSuper(CompetitorProductsAggregatorEachForProduct);

  function CompetitorProductsAggregatorEachForProduct() {
    var _this;

    (0, _classCallCheck2["default"])(this, CompetitorProductsAggregatorEachForProduct);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (_ref) {
      var state = _ref.state,
          attributes = _ref.attributes,
          validationErrors = _ref.validationErrors,
          competitorProductsRuleSet = _ref.competitorProductsRuleSet;
      productState[competitorProductsRuleSet.id] = {
        state: state,
        attributes: attributes,
        validationErrors: validationErrors
      };
      var competitorProductsRuleSets = _this.props.competitorProductsRuleSets; // This check is going to avoid onload callbacks...
      // It will ensure, after loading all the products it will give you a callback

      if (Object.keys(productState).length === competitorProductsRuleSets.length) {
        _this.props.onChange(productState);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getCompatitorProductsAttributeSelectors", function () {
      var _this$props = _this.props,
          competitorProductsRuleSets = _this$props.competitorProductsRuleSets,
          attributeConfigurations = _this$props.attributeConfigurations,
          authToken = _this$props.authToken;
      return (
        /*#__PURE__*/
        _react["default"].createElement(_react["default"].Fragment, null, (0, _map["default"])(competitorProductsRuleSets, function (competitorProductsRuleSet) {
          return (
            /*#__PURE__*/
            _react["default"].createElement(_react["default"].Fragment, {
              key: competitorProductsRuleSet.id
            },
            /*#__PURE__*/
            _react["default"].createElement("hr", {
              style: {
                backgroundColor: 'black',
                height: 1,
                marginTop: 5,
                marginBottom: 10
              }
            }),
            /*#__PURE__*/
            _react["default"].createElement("span", {
              style: {
                fontWeight: 'bold'
              }
            }, competitorProductsRuleSet.id, ":"),
            /*#__PURE__*/
            _react["default"].createElement("div", {
              style: {
                marginTop: 10
              }
            },
            /*#__PURE__*/
            _react["default"].createElement(_attributeSelector["default"], {
              ruleSet: competitorProductsRuleSet,
              authToken: authToken,
              onChange: function onChange(_ref2) {
                var state = _ref2.state,
                    attributes = _ref2.attributes,
                    validationErrors = _ref2.validationErrors;

                _this.onChange({
                  state: state,
                  attributes: attributes,
                  validationErrors: validationErrors,
                  competitorProductsRuleSet: competitorProductsRuleSet
                });
              },
              showErrorAlert: true,
              attributeConfigurations: attributeConfigurations[competitorProductsRuleSet.id] || {}
            })))
          );
        }))
      );
    });
    return _this;
  }

  (0, _createClass2["default"])(CompetitorProductsAggregatorEachForProduct, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!(0, _isEqual["default"])(prevProps.competitorProductsRuleSets, this.props.competitorProductsRuleSets)) {
        productState = {};
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.getCompatitorProductsAttributeSelectors();
    }
  }]);
  return CompetitorProductsAggregatorEachForProduct;
}(_react.PureComponent);

exports["default"] = CompetitorProductsAggregatorEachForProduct;
(0, _defineProperty2["default"])(CompetitorProductsAggregatorEachForProduct, "propTypes", {
  competitorProductsRuleSets: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  onChange: _propTypes["default"].func,
  authToken: _propTypes["default"].string.isRequired,
  attributeConfigurations: _propTypes["default"].shape({}),
  onError: _propTypes["default"].func
});
(0, _defineProperty2["default"])(CompetitorProductsAggregatorEachForProduct, "defaultProps", {
  onChange: function onChange() {},
  onError: function onError() {}
});